<template>
  
  <router-view />

  <p class="copyright">Copyright &copy; {{new Date().getFullYear()}} Discovery Holiday Parks</p>

</template>


